






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class BlockContainer extends Vue {
    @Prop({ type: String, default: 'white' }) readonly background!: boolean
    @Prop({ type: Array, default() { return [1] } }) readonly cols!: number[]
    @Prop({ type: Number, default: 0 }) readonly gap!: number
    @Prop({ type: Number, default: 1 }) readonly span!: number
    @Prop({ type: Array, default() { return [0] } }) readonly padding!: number[]

    get componentClass() {
        return {
            'block-container': true,
            ['block-container--background-' + this.background]: true,
            'block-container--flex': this.cols.length === 1,
        }
    }

    get variables() {
        return {
            '--block-container-fractions': this.cols.map(col => col.toString() + 'fr').join(' '),
            '--block-container-gap': this.gap,
            '--block-container-span': this.span,
            '--block-container-padding': this.padding.join('rem ') + 'rem',
        }
    }
}
